<template>
  <el-drawer :title="drwerTitle" :visible.sync="visible" size="40%" :append-to-body="true" :center="true" :wrapperClosable="false" :withHeader="false">
    <div class="fixed-btns">
      <div>{{drwerTitle}}</div>
      <div>
        <el-button type="primary" class="mr8" v-has="[137]" v-if="demand.item_check_status3==3 ||demand.item_check_status3==-1" @click="showDrawerPass(_self, 'editView', 'showDrawer', [demand,order,'four_edit'])">策划临时编辑</el-button>
        <el-button type="primary" v-has="[137]" v-if="demand.item_check_status1==2" @click.stop="showDrawerPass(_self, 'editorView', 'showFour', [demand,category.parent_id,'fourEdit'])">临时修改</el-button>
        <!-- 待审核 审核中 -->
        <!-- 编辑审核中 待审核-->
        <el-link type="primary" class="mr8" v-if="inArray([0,1], demand.item_check_status3)">编辑-{{getItemCheckTitle(demand.item_check_status3)}}</el-link>
        <!-- 编辑审核通过 -->
        <el-button type="primary" v-if="demand.item_check_status3==2" @click="showDrawerPass(_self, 'editView', 'showDrawer', [demand,'four_edit'])">编辑-{{getItemCheckTitle(demand.item_check_status3)}}</el-button>
        <!-- 编辑审核驳回 可修改 -->
        <el-link type="primary" class="mr8" v-if="demand.item_check_status3==3">编辑-{{getItemCheckTitle(demand.item_check_status3)}}</el-link>
        <el-button type="primary" class="closeBtn" @click="closeDrawer">关闭</el-button>
      </div>
    </div>
    <div class="draw-form">
      <div class="hs-list-group">
        <div class="hs-list-item">
          <div class="hs-col p20 align-left">婚庆承办公司</div>
          <div class="hs-col align-left">{{order.wedding.company}}</div>
        </div>
        <div class="hs-list-item">
          <div class="hs-col p20 align-left">婚期</div>
          <div class="hs-col align-left">{{order.order.event_date}}</div>
        </div>
        <div class="hs-list-item">
          <div class="hs-col p20 align-left">酒店</div>
          <div class="hs-col align-left">{{order.order.hotel}}</div>
        </div>
        <div class="hs-list-item">
          <div class="hs-col p20 align-left">新郎</div>
          <div class="hs-col align-left">{{order.order.bridegroom}}</div>
        </div>
        <div class="hs-list-item">
          <div class="hs-col p20 align-left">宴会类型</div>
          <div class="hs-col align-left" v-if="order.order.banquet_type">
          {{ dictionary.convertBanquetTypeToStr(order.order.banquet_type) ? dictionary.convertBanquetTypeToStr(order.order.banquet_type) : '-' }}
          </div>
        </div>
        <div class="hs-list-item">
          <div class="hs-col p20 align-left">宴会厅</div>
          <div class="hs-col align-left">{{order.hall}}</div>
        </div>
        <div class="hs-list-item">
          <div class="hs-col p20 align-left">类型</div>
          <div class="hs-col align-left">{{category.title}}</div>
        </div>

        <div class="hs-list-item">
          <div class="hs-col p20 align-left">策划师</div>
          <div class="hs-col align-left">{{demand.planner}}</div>
        </div>

        <div class="hs-list-item">
          <div class="hs-col p20 align-left">团队</div>
          <div class="hs-col align-left">
            <span class="mr8">{{demand.supplier}}</span>
            <!-- item_check_status1 分配 four_allocate item_check_status2 作废 four_abrogate item_check_status3 编辑 four_edit 
    {id:0, title: "待审核"},{id:1, title: "审核中"},{id:2, title: "审核通过"},{id:3, title: "审核驳回"},-->
            <!-- 第一次点击分配 -->
            <el-button v-if="demand.status==0 && demand.supplier_id==0 && !inArray([0,2], demand.item_check_status2)" type="primary" @click="showDrawerPass(_self, 'allocateView', 'showDialog', [category.parent_id,category.id,demand,order])">分配</el-button>
            <!-- 第一次点击分配状态 -->
            <el-link class="mr8" v-if="demand.status==0 && demand.supplier_id>0 && inArray([0,1], demand.item_check_status1)">已分配-{{getItemCheckTitle(demand.item_check_status1)}}</el-link>
            <!-- 审核通过 -->
            <el-button v-if="demand.status==1 && demand.supplier_id>0 && demand.item_check_status1 == '2'" type="primary">已分配-{{getItemCheckTitle(demand.item_check_status1)}}</el-button>
            <!-- 驳回审核 -->
            <el-button v-if="demand.status==0 && demand.supplier_id>0 && demand.item_check_status1 == '3'" type="primary" @click="showDrawerPass(_self, 'allocateView', 'showDialog', [category.parent_id,category.id,demand,order])">已分配-{{getItemCheckTitle(demand.item_check_status1)}}</el-button>

            <el-button v-if="demand.status==1" type="primary" @click="confirm()">确定</el-button>
            <el-button v-if="demand.status==1" type="primary" @click="showDrawerPass(_self, 'allocateView', 'showDialog', [category.parent_id,category.id,demand,order])">重新分配</el-button>

            <el-button v-if="demand.status!=4 && demand.item_check_status2 == '-1'" type="primary" @click="cancel()">作废</el-button>
            <!-- 第一次点击作废状态 -->
            <el-link class="mr8" v-if="demand.status!=4 && inArray([0,2], demand.item_check_status2)">作废-{{getItemCheckTitle(demand.item_check_status2)}}</el-link>
            <!-- 作废审核通过 -->
            <el-link class="ml8" v-if="demand.status==4 && demand.item_check_status2 == '2'">作废-{{getItemCheckTitle(demand.item_check_status2)}}</el-link>
            <!-- 作废驳回审核 -->
            <el-button v-if="demand.status==4 && demand.item_check_status2 == '3'" type="primary" @click="cancel()">作废-{{getItemCheckTitle(demand.item_check_status2)}}</el-button>

          </div>
        </div>
        <div class="hs-list-item">
          <div class="hs-col p20 align-left">姓名</div>
          <div class="hs-col align-left">{{demand.product}}</div>
        </div>
        <div class="hs-list-item" v-if="demand.other_fee">
          <div class="hs-col p20 align-left">其他金额</div>
          <div class="hs-col align-left">{{demand.other_fee}}</div>
        </div>
        <div class="hs-list-item">
          <div class="hs-col p20 align-left">分配时间</div>
          <div class="hs-col align-left">{{ demand.allocate_time ? demand.allocate_time : '待分配' }}</div>
        </div>

        <div class="hs-list-item" v-for="(rule,index) in category.rules" :key="index">
          <div class="hs-col p20 align-left">{{rule.label}}</div>
          <div class="hs-col align-left">{{getRuleTag(demand.addons, rule)}}</div>
        </div>

        <div class="hs-list-item">
          <div class="hs-col p20 align-left">备注</div>
          <div class="hs-col align-left">{{ demand.remark }}</div>
        </div>
      </div>
      <!-- 显示评论 -->
      <comment-view ref="commentView"></comment-view>
      <allocate-view ref="allocateView" :parent="_self"></allocate-view>
      <edit-view ref="editView" :parent="_self"></edit-view>
      <editor-view ref="editorView" :parent="_self"></editor-view>
    </div>
  </el-drawer>
</template>

<script>
import weddingUtils from '@/utils/wedding.js'
import {
  showDrawerPass,
  inArray,
  getItemCheckTitle
} from '@/utils/common.js';
import {
  has
} from '@/utils/promissions';
import allocateView from './allocate.vue';
import editView from './edit.vue';
import editorView from '@/components/editor/editor.vue';
// 新版本底部按钮
import commentView from '@/components/comment/comment.vue';
import dictionary from '@/utils/dictionary';
export default {
  components: {
    allocateView,
    commentView,
    editView,
    editorView
  },
  props: {
    parent: {}
  },
  data() {

    return {
      visible: false,
      demand: {},
      category: {},
      drwerTitle: '',
      id: 0,
      activeName: 'comment',
      squareUrl: "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
      Isshow: true,
      commentList: {},
      module: 'wedding_plan',
      module_id: 0,
      order: {
        wedding: {},
        order: {}
      },

    };
  },
  beforeCreate() {
    this.getRuleTag = weddingUtils.getRuleTag;
    this.inArray = inArray;
    this.showDrawerPass = showDrawerPass;
    this.getItemCheckTitle = getItemCheckTitle;
    this.dictionary=dictionary;
  },
  methods: {
    handleClick(tab, event) {
      if (tab.name == "record") {
        this.Isshow = false
      } else {
        this.Isshow = true
      }
    },
    getDate(row) {
      let _this = this;
      let url = '/api/wedding.four/read';
      let params = {
        id: row.id
      };

      this.$post(url, params).then(res => {
        _this.demand = res.data.row;
        _this.category = res.data.category;
        _this.drwerTitle = "分配" + _this.category.title;
        _this.module_id = res.data.row.id;
        if (_this.$refs['commentView']) {
          _this.$refs['commentView'].getComment(_this.module, _this.module_id, 'four');
        } else {
          _this.$nextTick(function () {
            _this.$refs['commentView'].getComment(_this.module, _this.module_id, 'four');
          })
        }
      });
    },
    showDrawer(row) {
      let _this = this;
      _this.visible = true;
      _this.id = row.id;
      _this.order = row;
      let url = '/api/wedding.four/read';
      let params = {
        id: row.id
      };

      this.$post(url, params).then(res => {
        _this.demand = res.data.row;
        _this.category = res.data.category;
        _this.drwerTitle = "分配" + _this.category.title;
        _this.module_id = res.data.row.id;
        if (_this.$refs['commentView']) {
          _this.$refs['commentView'].getComment(_this.module, _this.module_id, 'four');
        } else {
          _this.$nextTick(function () {
            _this.$refs['commentView'].getComment(_this.module, _this.module_id, 'four');
          })
        }
      });
    },
    confirm() {
      this.$confirm('是否确认和供应沟通完成?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url = '/api/wedding.four/confirm';
        let data = {
          id: this.id,
        };
        this.$post(url, data).then((res) => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.msg,
              showClose: true
            });
            this.showDrawer(this.order);
            this.parent.getTableData();
          } else {
            this.$message.error(res.msg);
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    cancel() {
      this.$confirm('是否确认作废?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url = '/api/wedding.four/cancel';
        let data = {
          id: this.id,
        };
        this.$post(url, data).then((res) => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.msg,
              showClose: true
            });
            this.showDrawer(this.order);
            this.parent.getTableData();
            this.demand.status = 4;
          } else {
            this.$message.error(res.msg);
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    closeDrawer() {
      this.visible = false;
    }
  }
}
</script>

<style lang="less">
@import url('@/assets/css/common.less');

.img {
    width: 100px;
    height: 100px;
    margin-right: 10px;
}

.apply-list {
    padding: 5px 0;
    display: block;
}

.fixed-btns {
    display: flex;
    height: 55px;
    width: 100%;
    text-align: right;
    padding-right: 24px;
    background: #f6f7fb;
    -webkit-box-pack: justify;
    justify-content: space-between;
    padding: 10px;
    line-height: 35px;
}
</style>
